import React from "react";
import { BreadcrumbLayoutItem } from "~/common/Store/models/Category";
const generateBreadcrumbSchema = (breadcrumbs: BreadcrumbLayoutItem[]) => {
  const url = "https://www.webstaurantstore.com";
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      position: index + 1,
      "@type": "ListItem",
      item: url + breadcrumb.link,
      name: breadcrumb.displayText
    }))
  };
};
export default function Breadcrumbs({
  breadcrumbs,
  olClassName
}: {
  breadcrumbs: BreadcrumbLayoutItem[];
  olClassName?: string;
}) {
  const filteredBreadcrumbs = breadcrumbs.filter(item => !["Eligible", "Quick Shipping"].includes(item.displayText));
  return <nav aria-label="breadcrumbs" className="container global-breadcrumb" data-sentry-component="Breadcrumbs" data-sentry-source-file="index.tsx">
      <ol className={`breadcrumb ${olClassName || ""}`}>
        {filteredBreadcrumbs.map((item, index) => index === filteredBreadcrumbs.length - 1 ? <li key={item.displayText}>
              <span aria-current="page">
                <span>
                  <span className="sr-only">Current: </span>
                  {item.displayText}
                </span>
              </span>
            </li> : <li key={item.displayText}>
              <a href={item.link}>
                <span>{item.displayText}</span>
              </a>
              <i className="icon-breadcrumb" aria-hidden="true" />
            </li>)}
      </ol>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(generateBreadcrumbSchema(filteredBreadcrumbs))
    }} />
    </nav>;
}